<script setup lang="ts">
  import DesHeading from '@/components/DesHeading.vue'
</script>

<template>
  <div class="flex flex-col items-center gap-3 pt-8 text-center">
    <img :src="'/dashboard/logo/designrr.png'" alt="Designrr" class="h-8" />
    <DesHeading level="1">What would you like to create?</DesHeading>
    <div class="text-black-40">Describe your idea or choose where to start below.</div>
  </div>
</template>
